import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { Main } from "./components";
import { RelatorioProdutosContext } from "./context/RelatorioProdutosContext";

export default function RelatorioProdutos() {
    const { setStartDate, setEndDate } = useContext(RelatorioProdutosContext);
    const { isLoading, setIsLoading } = useContext(LoadingContext);

    useEffect(() => {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const pad = n => String(n).padStart(2, "0");
        const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        setStartDate(fmt(start));
        setEndDate(fmt(end));
        setIsLoading(false);
    }, []);

    return isLoading ? <Loading /> : <Main />;
}
